import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TransferStateService} from '@scullyio/ng-lib'

@Injectable({
  providedIn: 'root'
})
export class DetailsPageResolver implements Resolve<any> {
  constructor(private http: HttpClient,
    private transferStateService:TransferStateService

  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {            
    const lang = route.url[0].path;
    const pagename = route.url[2].path;
    const filename = route.url[3].path;
    const title = route.url[4].path;        
    
    if (lang && pagename && filename && title) {
      // URLs for the main file and the meta-data file
      const contentUrl = `../../../assets/${environment.projectName}/content/${lang}/${pagename}/${filename}.json`;
      const metadataUrl = `../../../assets/${environment.projectName}/content/${lang}/${pagename}/meta-data.json`;

      // Use forkJoin to fetch both files in parallel
      return forkJoin({
        content: this.transferStateService.useScullyTransferState('details', this.http.get<any>(contentUrl).pipe(
          map((data) => {
            const article = data.services.find(
              (service: any) =>
                service.title.toLowerCase().replace(/ /g, '-') === title.toLowerCase()                
            );            
            return article || null;
          }),
          catchError((error) => {
            console.error('Error fetching article:', error);
            return of(null);
          })
        ))
        
        ,
        // Not used now
        metadata: this.transferStateService.useScullyTransferState('metadata',this.http.get<any>(metadataUrl).pipe(
          catchError((error) => {
            console.error('Error fetching metadata:', error);
            return of(null);
          })
        ))
      }).pipe(
        map((result) => {
          // Combine content and metadata into one object
          return { content: result.content, metadata: result.content.meta };
        })
      );
    } else {
      return of(null);
    }
  }
}
